import React from 'react'

const MediaCanvasItem = ({ item }) => {
  return (
    <div className='overflow-hidden h-full w-full'>
      <img className='block h-full w-full pointer-events-none object-cover' src={item.src} alt='' />
    </div>
  )
}

export default MediaCanvasItem
